export type ProductOnboardingMode = "invitation" | "internal_self_registration";

export function productOnboardingMode(
  configuredMode = publicRuntimeValue("VITE_PRODUCT_ONBOARDING_MODE", import.meta.env)
): ProductOnboardingMode {
  const mode = configuredMode?.trim() || "invitation";
  if (mode === "invitation" || mode === "internal_self_registration") return mode;
  throw new Error(`Unsupported Product Account onboarding mode: ${mode}`);
}
import { publicRuntimeValue } from "@matrix-idp/config/browser-runtime";
